import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup } from 'reactstrap'
import { getStore, resetStore } from '../../../../store/store/actions'
import { MainLoader } from '../../../../components'

class StoreDetail extends Component {

    componentDidMount() {
        this.props.getStore(this.props.match.params.id)
    }
    componentWillUnmount() {
        this.props.resetStore();
    }

    renderField(label, value) {

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>
        )
    }

    renderFields() {

        const store = this.props.store
        const userName = store.User != null ? store.User.name : ''

        return (
            <div>
                {this.renderField('Nombre:', store.name)}
                {this.renderField('RUC:', store.ruc)}
                {this.renderField('Razón Social:', store.businessName)}
                {this.renderField('Dirección:', store.address)}
                {this.renderField('Longitud:', store.longitude)}
                {this.renderField('Latitud:', store.latitude)}
                {this.renderField('Teléfono:', store.phone)}
                {store.openingHours && this.renderField('Horario de Atención:', store.openingHours)}
                {this.renderField('URL:', store.url)}
                {this.renderField('Usuario:', userName)}
            </div>
        )
    }

    render() {
        const { store, loading, error } = this.props

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }

        if (loading) {
            return <MainLoader />
        }
        else if (!store) return <div></div>

        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Detalle de la Tienda
                    </CardHeader>
                    <CardBody>
                        {this.renderFields()}
                        <Row>
                            <Col className='mt-3'>
                                <Button color='secondary' onClick={() => this.props.history.push('/administration/stores')} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { store, error, loading } = state.store.activeStore

    return {
        store,
        error,
        loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStore,
        resetStore
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetail)


// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreDetail/StoreDetail.js